import { useTableActionContext } from '@aibees/elephant/context';
import { useSearchTypeFromRoute } from '@aibees/elephant/hooks';
import { ROUTES } from '@aibees/elephant/router';
import { ElephantPresetType, SearchTable } from '@aibees/elephant/types';
import { useMatchRoute } from '@aibees/shared/hooks';

export function useExportTemplateDataType() {
  // Call the hook for each route individually
  const { integrationConfig } = useTableActionContext();
  const type = useSearchTypeFromRoute();
  const matchPeople1 = useMatchRoute(ROUTES.searchPeople);
  const matchPeople2 = useMatchRoute(ROUTES.peopleLookalike);
  const matchPeople3 = useMatchRoute(ROUTES.peopleUpdates);
  const matchPeople4 = useMatchRoute(ROUTES.peopleUpdatesContact);
  const matchPeople5 = useMatchRoute(ROUTES.peopleUpdatesProfile);
  const matchPeople6 = useMatchRoute(ROUTES.people);
  const matchPeople7 = useMatchRoute(ROUTES.companyEmployees);

  const isPeopleRoute = Boolean(
    matchPeople1 ||
      matchPeople2 ||
      matchPeople3 ||
      matchPeople4 ||
      matchPeople5 ||
      matchPeople6 ||
      matchPeople7
  );

  const matchCompany1 = useMatchRoute(ROUTES.company);
  const matchCompany2 = useMatchRoute(ROUTES.searchCompany);
  const matchCompany3 = useMatchRoute(ROUTES.companyLookalike);

  const isCompanyRoute = Boolean(
    matchCompany1 || matchCompany2 || matchCompany3
  );

  if (isPeopleRoute && !integrationConfig) {
    return ElephantPresetType.PEOPLE_SEARCH_EXPORT_SETTINGS_COLUMNS;
  }

  if (isCompanyRoute) {
    return ElephantPresetType.COMPANY_SEARCH_EXPORT_SETTINGS_COLUMNS;
  }

  if (isPeopleRoute && !!integrationConfig) {
    return ElephantPresetType.INTEGRATION_EXPORT_SETTINGS_COLUMNS;
  }
  const presetTypeMap: Record<SearchTable, ElephantPresetType> = {
    [SearchTable.Company]:
      ElephantPresetType.COMPANY_SEARCH_EXPORT_SETTINGS_COLUMNS,
    [SearchTable.People]:
      ElephantPresetType.PEOPLE_SEARCH_EXPORT_SETTINGS_COLUMNS,
    [SearchTable.Employees]:
      ElephantPresetType.PEOPLE_SEARCH_EXPORT_SETTINGS_COLUMNS,
    [SearchTable.BuyingTeam]: ElephantPresetType.BUYING_TEAM_MATRIX,
  };

  const defaultPresetType =
    ElephantPresetType.COMPANY_SEARCH_EXPORT_SETTINGS_COLUMNS;
  return integrationConfig
    ? ElephantPresetType.INTEGRATION_EXPORT_SETTINGS_COLUMNS
    : type
    ? presetTypeMap[type]
    : defaultPresetType;
}
